<template>
	<div>
		<div  class="flex step3" v-loading="loading">
										<div class="flex" style="justify-content: center;align-items: center">
												<div>
													<div style="width: 50px;margin: 0 auto 10px" >
															<img v-if="status==1" src="@/assets/img/dataImport/zhuyi-2.png" style="width:100%" alt="" srcset="">
															<img v-if="status==2" src="@/assets/img/dataImport/tishi copy 2.png" style="width:100%" alt="" srcset="">
															<img v-if="status==3" src="@/assets/img/dataImport/dui.png" style="width:100%" alt="" srcset="">
													</div>
													<div class="tishi" style="text-align: center">
														<h3  v-if="status==1">校验未通过</h3>
														<h3  v-if="status==2" style="color: #FF9F00;">校验通过,但有警告或提示信息</h3>
														<h3  v-if="status==3" style="color: #13ce66;">校验通过</h3>
														<p v-if="status==1" style="margin: 4px 0 20px;font-size: 12px;color: red;">导入共计{{this.step3Info.total}}人,校验通过{{this.step3Info.success}}人,未通过{{this.step3Info.failure}}人</p>
														<p v-if="status==2" style="margin: 4px 0 20px;font-size: 12px;color: #FF9F00;">导入共计{{this.step3Info.total}}人,校验通过{{this.step3Info.success}}人</p>
														<p v-if="status==3" style="margin: 4px 0 20px;font-size: 12px;color: #13ce66;">导入共计{{this.step3Info.total}}人，校验通过{{this.step3Info.total}}人</p>
														<p class="p2" v-if="status==1 || status==2" >您可以通过  <font @click="_exportTable">导出</font> 错误结果文件</p>
														<p class="p2" v-if="status==1 || status==2" >修改完成<font @click="changeStatus()">再次上传</font></p>
													</div>
												</div>

										</div>
										<div class="errorCon" style="width: 680px;height: 370px;margin: 0 auto;overflow: auto;" v-if="status!=3">
											<div v-if="step3Info.tipsMessages && step3Info.tipsMessages.length>0">
												<h3><img src="@/assets/img/dataImport/tishi.png" alt="" /><span>提示</span></h3>
                        <p v-for="(item,i) in step3Info.tipsMessages" :key="i">{{i+1}}: {{item}}</p>
											</div>
											<div v-if="step3Info.warnMessages && step3Info.warnMessages.length>0">
												<h3><img src="@/assets/img/dataImport/tishi copy.png" alt="" /><span>警告</span></h3>
                        <p v-for="(item,i) in step3Info.warnMessages" :key="i">{{i+1}}: {{item}}</p>
											</div>
											<div v-if="step3Info.errorMessages && step3Info.errorMessages.length>0">
												<h3><img src="@/assets/img/dataImport/guanbi-3 copy 19.png" alt="" /><span>错误</span></h3>
												<p v-for="(item,i) in step3Info.errorMessages" :key="i">{{i+1}}: {{item}}</p>
											</div>
										</div>

		</div>
		<div v-if="status==2||status==3" style="margin-top: 70px;padding-bottom: 24px;text-align:center;">
      <el-button type="primary" @click="upStep()">上一步</el-button>
      <el-button type="primary" @click="next()">下一步</el-button>
		</div>
	</div>



</template>

<script>
  import {exportTable, uploadStepThree,checkBatchName} from "@/api/wage/batchTemplate";
  import {downloadFile} from "@/util/util";
  export default {
    name: "step3",
    props: {
       step: {
       	type: String,
       	default: '',
       },
       step3Info:{
        type: Object,
         default: ()=>({})
       },
      step4Info: {
        type: Object,
        default: {},
      },
      formInline:{//父页面传入的批次信息
        type: Object,
        default: {}
      },
      batchInfoDetail:{//父页面传入的批次信息
        type: Object,
        default: {}
      },
      payGroupId:{
        type: String,
        default: '',
      },
      orgId:{
        type: String,
        default: '',
      },
      batchName:{
        type: String,
        default: '',
      },
    },
    data() {
      return {
				status:1,
        loading:false
        // errorList:[],
      };
    },
    created(){
      let suceess = this.step3Info.success;
      let total = this.step3Info.total;
      // this.errorList = this.step3Info.errorMessages;
      /*this.status = 2;//都成功了才可以下一步导入完成
      if(total == total){
        this.status = 2;//都成功了才可以下一步导入完成
      }*/
      this.$set(this, 'status', this.formInline.status)
    },
    methods: {
        upStep(){
          this.$emit('update:step', 'step2')
        },
				next(){
				  //修改下一步时，提交数据
        let params = {
          batchInfo:{"salaryTemplateId":this.formInline.templateId,"remark":"测试用"},
          batchInfoDetail:this.batchInfoDetail,
          payGroupId:this.payGroupId,
          orgId:this.orgId,
          region:this.formInline.region,//服务id
          procName:this.formInline.procName,//服务组合名
          batchId:this.step3Info.batchId,//获取第二步返给第三步的批次信息
          templateId:this.formInline.templateId,//所选模板id
          taxType:this.formInline.taxTypeList,//计税类型
          total:this.step3Info.total//总人数
        }
        let messageShow = '是否确认导入'
        if(this.step3Info.warnMessages && this.step3Info.warnMessages.length>0){
          messageShow='存在警告信息,是否确认导入';
        }
          this.$confirm(messageShow,'提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{

            let param={
              'batchName':this.batchName
            }
            this.loading=true;
            checkBatchName(param).then(res=>{
              let i = res.data.data
              if(i>0){
                this.loading=false;
                this.$message.warning('批次名称不能重复');
              }else{
                uploadStepThree(params).then(res=>{
                  this.loading=false;
                  let rs = res.data
                  if(rs.code==0){
                    this.$emit('update:step', 'step4');
                    this.$set(this.step4Info,'confirmBtn',rs.data.isOnlyWage);
                    this.$emit('update:step4Info',this.step4Info);
                  }
                });
              }
            })
          })
				},
				changeStatus(){
				  let param = {
            templateId:this.step3Info.templateId,
            batchId:this.step3Info.batchId
          }
					//this.status = 2;
          this.$emit('update:step', 'step1')
          this.$emit('update:disabled',false);//导入栏是否可编辑
				},
      //导出错误信息
      _exportTable(){
        let params = {
          beanName: 'wageBatchInfoServiceImpl',
          methodName: 'findDetailTempListMapByParams',
          batchId: this.step3Info.batchId,
          templateId: this.step3Info.templateId,
          isSort: true,
          headerRowNum: 2,
          fileName: "导入批次异常信息.xls",
          region:this.formInline.region,//服务id
          type: "excel"
        };
        exportTable(params).then(res=>{
          downloadFile(res)
        });
      }
    }
  };
</script>

<style scoped >
	.flex{
		display: flex;
	}
 /*  .step3 > div{
   	width: 50%;
   } */
   .step3{
   	padding: 36px 140px;
		box-sizing: border-box;
		justify-content: space-around;
   }
   .errorCon{
   	min-width:330px;
   	padding: 10px 20px;
   	background:rgba(255,237,237,1);
   	border-radius:4px;
   	box-sizing: border-box;
   }
   .errorCon>div{
   	margin-bottom: 18px;
   }
   .errorCon>div:nth-last-of-type(1){
   	margin-bottom: 0;
   }
   .errorCon>div h3{
   		font-size:13px;
   		font-family:PingFangSC-Medium,PingFang SC;
   		font-weight:500;
   		color:rgba(51,51,51,1);
   		line-height:18px;
   	}
		.errorCon>div h3 img,.errorCon>div h3 span{
			vertical-align: middle;
		}
		.errorCon>div h3 img{
			margin-right: 9px;
		}
   .errorCon>div p{
   	font-size:12px;
   	font-family:PingFangSC-Regular,PingFang SC;
   	font-weight:400;
   	color:rgba(102,102,102,1);
   	line-height:17px;
   	margin-top: 4px;
		padding-left: 23px;
   }
	 .tishi h3{
	 	font-size:15px;
	 	font-family:PingFangSC-Medium,PingFang SC;
	 	font-weight:500;
	 	color:rgba(255,0,0,1);
	 	line-height:21px;
	 }
	 .tishi .p2{
	 	font-size:13px;
	 	font-family:PingFangSC-Regular,PingFang SC;
	 	font-weight:400;
	 	color:rgba(51,51,51,1);
	 	line-height:18px;
		white-space: nowrap;
		padding-right: 30px;
     text-align: left;
	 }
	 .tishi .p2 font,.step4>div p font{
	 	color: #0EA5E5;
	 	padding: 0 4px;
	 	cursor: pointer;
	 }
</style>
